import React, { useState, useEffect, useMemo } from 'react';

import { Box } from '@chakra-ui/react';

import { ButtonGroup } from 'components/DataEntry';
import { DashboardWidget } from 'components/Visualization/CDashboard/Widget/DashboardWidget';
import { BarChart, LineChart } from 'components/Visualization/Charts';
import {
  vulnerabilityChartColorMap,
  vulnerabilityChartItems,
} from 'containers/Visibility/Vulnerabilities/Components/utils';
import { VulnerabilityChartProps } from 'containers/Visibility/Vulnerabilities/types';

import { formatDate } from '../../../../../../utils/date';
import { criticalOrHighVulnerabilitiesChartStyles } from '../styles';

export const VulnerabilitiesBySeverityChart = (
  props: VulnerabilityChartProps,
) => {
  const {
    showResolved = false,
    cumulative = false,
    severities,
    chartType,
    updateValue,
  } = props;
  const [data, setData] = useState<any>();

  useEffect(() => {
    const totals: Record<string, number> = {};
    setData(
      Object.entries(severities.data ?? {}).map(
        ([date, item]: [string, any]) => {
          const values = { ...item };
          if (cumulative) {
            Object.entries(values).forEach(([severity, value]) => {
              totals[severity] = (totals[severity] ?? 0) + Number(value ?? 0);
              values[severity] = totals[severity];
            });
          }
          return { Date: formatDate(date, 'D-MMM'), ...values };
        },
      ),
    );
  }, [severities.data, cumulative]);

  const commonFields = useMemo(
    () => ({
      xField: 'Date',
      yField: ['Critical', 'High', 'Medium', 'Low', 'Unknown'],
      data: data,
      isLoading: severities.isLoading,
      colorMap: vulnerabilityChartColorMap,
      styles: criticalOrHighVulnerabilitiesChartStyles,
    }),
    [data, severities.isLoading],
  );

  return (
    <DashboardWidget
      label={`${
        showResolved ? 'Resolved' : 'Open'
      } Vulnerabilities – By Severity`}
      subHeader="Last 7 Days"
      rightHeader={
        <ButtonGroup
          items={vulnerabilityChartItems}
          value={chartType}
          onClick={updateValue}
          styles={{ button: { size: 'xs' } }}
        />
      }
      content={
        <Box w="full" h="full">
          {chartType?.value === 'line' ? (
            <LineChart {...commonFields} />
          ) : (
            <BarChart {...commonFields} stacked />
          )}
        </Box>
      }
      styles={{
        contentWrapper: { px: 0, pt: 0, pb: 1 },
        rightHeader: { hStack: { w: 'full', h: 'full', align: 'start' } },
      }}
    />
  );
};
